import(/* webpackMode: "eager" */ "/vercel/path0/app/eventos/page.tsx");
